module.exports = __webpack_public_path__ + "static/media/icbc.74673608.svg";